import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, ROW_COUNT, API_ADMIN_PROVEEDOR, API_ADMIN_TIPO_PROVEEDOR, API_ADMIN_PRODUCTO } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { IAreaResponsable } from "../../../entities/IAreaResponsable";
import { IProducto } from "../../../entities/IProducto";
import { IProveedor } from "../../../entities/IProveedor";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import { cParamsActiveOrderTitle } from "../../../helpers/paramsHelper";
const columnHelperProveedor = createColumnHelper<IProveedor>();
interface IProveedorProps {
  cbAreaResponsable?: Array<IAreaResponsable>;
  cbProducto?: Array<IProducto>;
  items?: Array<any>;
}

const Proveedor = ({ cbAreaResponsable, cbProducto, items }: IProveedorProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [comboAr, setComboAr] = useState<Array<IAreaResponsable>>(cbAreaResponsable || []);
  const [comboPr, setComboPr] = useState<Array<IProducto>>(cbProducto || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [tipoProveedorFormAdd, setTipoProveedorFormAdd] = useState("");
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentSearch = () => {
    return (
      <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
        <i className="bi bi-search"></i>
      </a>
    );
  };

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);

    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let paramsActive = cParamsActiveOrderTitle;
    let result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    let pages = result.pages;
    setPages(pages);
    setListItems(list);
    params.PAGINADO = ROW_COUNT;
    const getCombo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result
      .data;
    setComboAr(getCombo);
    const getComboPr = (await getAPI(`${URL_SUPPORT}${API_ADMIN_PRODUCTO}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboPr(getComboPr);
    setIsLoading(false);
  }, [token]);
  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: Partial<IProveedor>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.PRODUCTO = filter.ID_PRODUCTO?.toString();
    filter.TIPO_PROVEEDOR = filter.ID_TIPO_PROVEEDOR?.toString();
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: IProveedor, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.ID_PRODUCTO = value.ID_PRODUCTO || 1;
    value.ID_TIPO_PROVEEDOR = value.ID_TIPO_PROVEEDOR || 1;
    if (value.ID === "") {
      delete value.ID;
    }

    if (value.ID_TIPO_PROVEEDOR === 1) {
      value.PROVEEDOR_EXTERNO = null;
      value.PROVEEDOR_EXTERNO_DISPLAY = null;
    } else {
      value.USUARIOS = null;
      value.USUARIOS_DISPLAY = null;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID !== undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let columns = [
    columnHelperProveedor.accessor("ID", {
      id: "ID",
      cell: (info: CellContext<IProveedor, number>) => info.getValue(),
      header: () => component("ID"),
      tipo: ITipo_Campo.key,
      title: "ID",
    } as any),
    columnHelperProveedor.accessor((row) => row.PROVEEDOR, {
      id: "PROVEEDOR",
      cell: (info: CellContext<IProveedor, number>) => componentValue(info.getValue()),
      header: () => component("Proveedor"),
      tipo: ITipo_Campo.text,
      title: "Proveedor",
      required: true,
    } as any),
    columnHelperProveedor.accessor((row) => row.TIPO_PROVEEDOR, {
      id: "ID_TIPO_PROVEEDOR",
      cell: (info: CellContext<IProveedor, number>) => componentValue(info.getValue()),
      header: () => component("Tipo Proveedor"),
      tipo: ITipo_Campo.combo,
      title: "Tipo Proveedor",
      callback: (id: string, value: string) => {
        if (id === "ID_TIPO_PROVEEDOR") {
          setTipoProveedorFormAdd(value);
        }
      },
      required: true,
    } as any),
    columnHelperProveedor.accessor((row) => row.PRODUCTO, {
      id: "ID_PRODUCTO",
      cell: (info: CellContext<IProveedor, number>) => componentValue(info.getValue()),
      header: () => component("Producto"),
      tipo: ITipo_Campo.combo,

      title: "Producto",
      required: true,
    } as any),
    columnHelperProveedor.accessor((row) => row.TIPO_PROCESO, {
      id: "TIPO_PROCESO",
      cell: (info: CellContext<IProveedor, number>) => componentValue(info.getValue()),
      header: () => component("Tipo Proceso"),
      tipo: ITipo_Campo.none,
      title: "Tipo Proceso",
    } as any),
    columnHelperProveedor.accessor((row) => row.AREA_RESPONSABLE, {
      id: "AREA_RESPONSABLE",
      cell: (info: CellContext<IProveedor, number>) => componentValue(info.getValue()),
      header: () => component("Área Responsable"),
      tipo: ITipo_Campo.none,
      title: "Área Responsable",
    } as any),
    columnHelperProveedor.accessor((row) => row.USUARIOS_DISPLAY, {
      id: "USUARIOS",
      cell: (info: CellContext<IProveedor, number>) => componentValue(info.getValue()),
      header: () => component("Usuario Proveedor Interno"),
      tipo: tipoProveedorFormAdd === "1" ? ITipo_Campo.user : ITipo_Campo.none,
      title: "Usuario Proveedor Interno",
    } as any),
    columnHelperProveedor.accessor((row) => row.PROVEEDOR_EXTERNO_DISPLAY, {
      id: "PROVEEDOR_EXTERNO",
      cell: (info: CellContext<IProveedor, number>) => componentValue(info.getValue()),
      header: () => component("Usuario Proveedor Externo"),
      tipo: tipoProveedorFormAdd === "2" ? ITipo_Campo.user : ITipo_Campo.none,
      title: "Usuario Proveedor Externo",
    } as any),
    columnHelperProveedor.accessor((row) => row.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IProveedor, boolean>) => componentValue(info.getValue() === true ? "Sí" : "No"),
      header: () => component("Activo"),
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperProveedor.display({
      id: "editar",
      header: () => component("Editar"),
      cell: (props) => componentSearch(),
    }),
  ];

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit({ ID: "", ACTIVO: true, ORDENADOPOR: "", ORIENTACION: "", PAGINA: 1, PAGINADO: 10, TITULO: "", PROVEEDOR: "" }, {});
          paging(1);
          filter(false as unknown as Partial<IProveedor>, false, 1);
        }}></button>
      <AdminLista
        items={[
          {
            type: "ID_TIPO_PROVEEDOR",
            value: comboAr.map((ar) => {
              return { text: ar.TITULO, value: ar.ID };
            }),
          },
          {
            type: "ID_PRODUCTO",
            value: comboPr.map((ar) => {
              return { text: ar.TITULO, value: ar.ID };
            }),
          },
        ]}
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"Proveedor"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Proveedor"
        columnsDef={columns}
        parentchild={(id: string, value: string) => {
          if (id === "ID_TIPO_PROVEEDOR") {
            setTipoProveedorFormAdd(value);
          }
        }}
        callbackRenderForm={(selected) => {
          setTipoProveedorFormAdd(selected["ID_TIPO_PROVEEDOR"] || "");
        }}
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default Proveedor;
